module.exports = __webpack_public_path__ + "img/pingb.88f95486.png";